module.exports = __webpack_public_path__ + "static/img/icono-aplicacion.b667cce7.svg";